export default __webpack_public_path__ + "static/media/promos-icon.df907884.webp";